import { SubscriptionEvent } from 'nekst-api';

export function useSubscriptionEventHelper() {
  const getLabel = (type: SubscriptionEvent) => {
    const map = {
      [SubscriptionEvent.TRANSACTION_LAUNCHED]: 'Transaction Launched',
      [SubscriptionEvent.TRANSACTION_UPDATED]: 'Transaction Updated',
      [SubscriptionEvent.CONTACT_CREATED]: 'Contact Created',
      [SubscriptionEvent.CONTACT_UPDATED]: 'Contact Updated',
      [SubscriptionEvent.CONTACT_DELETED]: 'Contact Deleted',

      [SubscriptionEvent.TRANSACTION_NOTE_CREATED]: 'Transaction Note Created',
      [SubscriptionEvent.TRANSACTION_NOTE_UPDATED]: 'Transaction Note Updated',
      [SubscriptionEvent.TRANSACTION_NOTE_DELETED]: 'Transaction Note Deleted',

      [SubscriptionEvent.TRANSACTION_ASSIGNMENT_CREATED]: 'Transaction Assignment Created',
      [SubscriptionEvent.TRANSACTION_ASSIGNMENT_DELETED]: 'Transaction Assignment Deleted',

      [SubscriptionEvent.CONTACT_NOTE_CREATED]: 'Contact Note Created',
      [SubscriptionEvent.CONTACT_NOTE_UPDATED]: 'Contact Note Updated',
      [SubscriptionEvent.CONTACT_NOTE_DELETED]: 'Contact Note Deleted',
    };

    return map[type];
  };

  return {
    getLabel,
  };
}
